import { useState, useEffect } from 'react'

type ScrollDirection = {
  isScrollingUp: boolean
}

const useScrollDirection = (): ScrollDirection => {
  const [isScrollingUp, setIsScrollingUp] = useState<boolean>(true)
  const [debouncedValue, setDebouncedValue] = useState(true)

  useEffect(() => {
    let lastScrollPosition = window.scrollY

    const handleScroll = () => {
      const currentScrollPosition = window.scrollY

      if (currentScrollPosition <= 30) {
        setIsScrollingUp(true)
      } else if (currentScrollPosition <= lastScrollPosition) {
        setIsScrollingUp(true)
      } else {
        setIsScrollingUp(false)
      }

      lastScrollPosition = currentScrollPosition
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(isScrollingUp)
    }, 20)

    return () => {
      clearInterval(handler)
    }
  }, [isScrollingUp])

  return { isScrollingUp: debouncedValue }
}

export default useScrollDirection
